import CompanySatEquipmentsSelect from '@/components/Companies/CompanySatEquipmentsSelect';
import { FloatingFormItem } from '@/components/_common';
import { useDefaultEmptyFieldError, useDisclosure } from '@/hooks';
import { Button, Form, Modal, Typography } from 'antd';
import { useInvoiceCFEFormContext } from '../../InvoiceCFEFormProvider';
import { useTaxCouponGenerateTx2 } from '@/core/domain/coupon/coupons/coupons.hooks';
import moment from 'moment';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

const InvoiceCFEDownload: React.FC = () => {
  const [form] = Form.useForm();
  const { taxCoupon } = useInvoiceCFEFormContext();

  const ruleRequired = useDefaultEmptyFieldError();

  const [modalOpened, modalAction] = useDisclosure(false);

  const generateTx2 = useTaxCouponGenerateTx2();

  async function handleSubmit() {
    try {
      if (taxCoupon) {
        if (!taxCoupon?.payments.length) {
          Modal.warn({
            title: 'Dados de pagamento',
            content: 'É necessário informar pelo menos uma forma de pagamento.',
            okText: 'Fechar',
          });

          throw new Error();
        }

        if (!taxCoupon?.couponItems.length) {
          Modal.warn({
            title: 'Itens do cupom',
            content:
              'É necessário informar pelo menos um item do cupom fiscal.',
            okText: 'Fechar',
          });

          throw new Error();
        }

        const { equipmentId } = await form.validateFields(['equipmentId']);

        const result = await generateTx2.mutateAsync({
          couponId: taxCoupon?.id,
          equipmentId,
        });

        const blob = new Blob([result], { type: 'text/plain' });
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');

        a.href = objectUrl;
        a.download = `${taxCoupon.id}_cfe_${moment().format(
          'DDMMYYYY-HHmmss',
        )}.txt`;
        a.click();

        URL.revokeObjectURL(objectUrl);
        document.removeChild(a);

        modalAction.close();
      }
    } catch {}
  }

  function handleClose() {
    form.resetFields();
    modalAction.close();
  }

  return (
    <>
      <Button
        type="primary"
        ghost
        onClick={modalAction.open}
        disabled={
          !hasPermissions([Authorities.FISCAL_COUPON_UPLOAD_DOWNLOAD_SAT_FILE])
        }
      >
        Baixar o arquivo
      </Button>

      <Modal
        title="Selecionar caixa"
        open={modalOpened}
        onCancel={handleClose}
        onOk={handleSubmit}
        okText="Baixar CF-e"
      >
        <p>Informe o equipamento SAT para baixar o arquivo CF-e.</p>

        <Form form={form}>
          <FloatingFormItem
            name="equipmentId"
            label="Selecione o caixa"
            rules={[ruleRequired]}
            extra={
              <Typography.Link
                href={`/app/registry/companies/${taxCoupon?.companyId}/coupon`}
                target="_blank"
              >
                Gerenciar equipamentos
              </Typography.Link>
            }
          >
            <CompanySatEquipmentsSelect companyId={taxCoupon?.companyId} />
          </FloatingFormItem>
        </Form>
      </Modal>
    </>
  );
};

export default InvoiceCFEDownload;
